import { useCommonProps } from './useCommonProps';
/**
 * Responsible for extracting common props for radio and checkbox
 * controls.
 */
export const useCheckboxRadioProps = (props) => {
    const { shape, plain, icon, indeterminate, hasFocus, ...rest } = props;
    return { shape, plain, icon, indeterminate, ...useCommonProps(rest) };
};
